import { put } from 'redux-saga/effects';
import makeRequest from '../../../utils/makeRequest';
import {
  SERVICE_HEALTH_CHECKS,
  getServiceKeysByMenuNames,
  isServiceUnavailableStatus,
} from '../serviceAvailability';
import { setServicesAvailability } from '../actions';

const checkService = function* checkService(serviceKey) {
  const config = SERVICE_HEALTH_CHECKS[serviceKey];

  if (!config) {
    return {
      available: true,
      checked: true,
    };
  }

  const response = yield makeRequest(
    config.url,
    config.params || {},
    null,
    config.method || 'GET',
    true,
  );

  const unavailable = isServiceUnavailableStatus(response?.status);

  return {
    available: !unavailable,
    checked: true,
  };
};

export default function* checkServicesAvailability(action) {
  const menuNames = action?.payload?.menuNames;
  const keys = Array.isArray(menuNames) && menuNames.length
    ? getServiceKeysByMenuNames(menuNames)
    : Object.keys(SERVICE_HEALTH_CHECKS);

  if (!keys.length) {
    return;
  }

  const payload = {};

  for (let i = 0; i < keys.length; i += 1) {
    const serviceKey = keys[i];
    payload[serviceKey] = yield* checkService(serviceKey);
  }

  yield put(setServicesAvailability(payload));
}
